import { Controller, useFormContext } from 'react-hook-form'
import type { EInvoiceDraftValues } from '@/lib/schemas/einvoice-draft-schemas'
import { Field } from '@/components/ui/field'
import { Input } from '@/components/ui/input'
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from '@/components/ui/select'
import { m } from '@/lib/paraglide/messages'
import { twJoin } from '@/lib/utils'

export function EInvoiceBuyerFields() {
    const form = useFormContext<EInvoiceDraftValues>()
    const company = form.watch('invoice_buyer.buyer_type') === 'company'
    return (
        <div className="grid gap-4 sm:grid-cols-2">
            <Field
                name="invoice_buyer.buyer_type"
                className="space-y-1.5 sm:col-span-2"
                label={m.order_form_invoice_buyer_type()}
            >
                <Controller
                    name="invoice_buyer.buyer_type"
                    control={form.control}
                    render={({ field }) => (
                        <Select
                            value={field.value}
                            onValueChange={(value) => {
                                field.onChange(value)
                                form.setValue('invoice_buyer.buyer_name', '')
                            }}
                        >
                            <SelectTrigger id="invoice_buyer.buyer_type">
                                <SelectValue />
                            </SelectTrigger>
                            <SelectContent>
                                <SelectItem value="consumer">
                                    {m.order_form_invoice_buyer_type_consumer()}
                                </SelectItem>
                                <SelectItem value="company">
                                    {m.order_form_invoice_buyer_type_company()}
                                </SelectItem>
                            </SelectContent>
                        </Select>
                    )}
                />
            </Field>
            <Field
                name="invoice_buyer.buyer_name"
                className={twJoin('space-y-1.5', !company && 'sm:col-span-2')}
                label={
                    company
                        ? m.einvoice_buyer_company_name()
                        : m.einvoice_buyer_person_name()
                }
                required={company}
            >
                <Input
                    id="invoice_buyer.buyer_name"
                    {...form.register('invoice_buyer.buyer_name')}
                />
            </Field>
            {company ? (
                <>
                    <Field
                        name="invoice_buyer.tax_code"
                        label={m.order_form_invoice_buyer_tax_code()}
                        required
                    >
                        <Input
                            id="invoice_buyer.tax_code"
                            {...form.register('invoice_buyer.tax_code')}
                        />
                    </Field>
                    <Field
                        name="invoice_buyer.address"
                        className="space-y-1.5 sm:col-span-2"
                        label={m.order_form_invoice_buyer_address()}
                        required
                    >
                        <Input
                            id="invoice_buyer.address"
                            {...form.register('invoice_buyer.address')}
                        />
                    </Field>
                    <Field
                        name="invoice_buyer.email"
                        className="space-y-1.5 sm:col-span-2"
                        label={m.order_form_invoice_buyer_email()}
                    >
                        <Input
                            id="invoice_buyer.email"
                            inputMode="email"
                            {...form.register('invoice_buyer.email')}
                        />
                    </Field>
                </>
            ) : (
                <p className="text-sm text-muted-foreground sm:col-span-2">
                    {m.einvoice_buyer_consumer_hint()}
                </p>
            )}
        </div>
    )
}
